import { getValue } from "@utils/lodash";
import React from "react";
import "../index.scss";
import _ from "lodash";
import moment from "moment";
import ExpenseTableDetailSection from "../../components/ExpenseTableDetailSection";

function DetailContainerDetail(props: any) {
  // console.log(JSON.stringify(getValue(props,`formInfo.expense_entry_cf`,{})))

  const expenseEntryData = getValue(props, "formInfo.expense_entry_cf", {});
  const linkedExpenses = getValue(props, "formInfo.linked_expenses", []);

  // Extract non-null key-value pairs into an array of objects
  const data = _.chain(expenseEntryData)
    .omitBy(_.isNull)
    .map((value: any, label: any) => ({ value, label }))
    .value();

  const formatDate = (inputDate: string) => {
    // const parsedDate = moment(inputDate);
    const parsedDate = moment(inputDate, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
    // Check if the parsed date is valid
    if (parsedDate.isValid()) {
      // Format the date to "DD MMM YYYY" format
      const formattedDate = parsedDate.format("DD MMM YYYY");
      // console.log(formattedDate); // Output: 29 Feb 2024
      return formattedDate
    } else {
      return inputDate;
    }
  };
  return (
    <div className="expense_detail_container_wrapper">
      {/* {getValue(props, `formInfo.description`, "") && ( */}
      <div className="desc_container pb-0">
        <h5 className="label_text">Description</h5>
        <p className="header_text">
          {getValue(props, `formInfo.description`, "")
            ? getValue(props, `formInfo.description`, "")
            : "-"}
        </p>
      </div>

      <div className="border-bottom border-bottom-spacing-expense-detail-wrap"></div>

      {getValue(data, `length`, 0) > 0 &&
        data.map((item: object, idx: number) => {
          return (
            <div key={idx} className="desc_container">
              <h5 className="label_text">{getValue(item, `label`, "")}</h5>
              <p className="header_text">
                {getValue(item, `value`, "")
                  ? formatDate(getValue(item, `value`, ""))
                  : "-"}
              </p>
            </div>
          );
        })}

      {getValue(linkedExpenses, "length", 0) > 0 && (
        <ExpenseTableDetailSection linkedExpenses={linkedExpenses} />
      )}
    </div>
  );
}

export default DetailContainerDetail;
